// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1jXMN","title":"BackImages_title__4N3cR","images":"BackImages_images__2I3CC"};